import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Heart = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/bold/heart">
        <g id="heart">
          <path
            id="Vector"
            d="M10.9626 2.06689C9.75594 2.06689 8.67594 2.65356 8.0026 3.55356C7.32927 2.65356 6.24927 2.06689 5.0426 2.06689C2.99594 2.06689 1.33594 3.73356 1.33594 5.79356C1.33594 6.58689 1.4626 7.32023 1.6826 8.00023C2.73594 11.3336 5.9826 13.3269 7.58927 13.8736C7.81594 13.9536 8.18927 13.9536 8.41594 13.8736C10.0226 13.3269 13.2693 11.3336 14.3226 8.00023C14.5426 7.32023 14.6693 6.58689 14.6693 5.79356C14.6693 3.73356 13.0093 2.06689 10.9626 2.06689Z"
          />
        </g>
      </g>
    </svg>
  );
};

Heart.displayName = 'Heart';
